import { HttpClient } from '../../httpClient'
import {
  OpalApiRequestParams,
  OpalApiRequestBody,
  OpalApiResponseDocument,
} from '../../schema'

interface UpdateMomentArguments {
  params: OpalApiRequestParams<'UpdateMomentScheduleV3'>
  requestBody: OpalApiRequestBody<'UpdateMomentScheduleV3'>
}

export async function updateMomentSchedule({
  params,
  requestBody,
}: UpdateMomentArguments): Promise<
  OpalApiResponseDocument<'UpdateMomentScheduleV3', 201>
> {
  const url = new URL(
    `/moment_schedules/v3/${params.path.moment_schedule_id}`,
    window.location.origin
  )
  return HttpClient()
    .patch(url.toString(), requestBody)
    .then((res) => res.data)
}
